<template>
    <div class="main">
        <div class="p-absolute" style="overflow: hidden; width: 100%">
            <div class="full-screen parallax cover" 
                 v-bind:style="{ backgroundImage: 'url(' + require('../assets/images/details-page/'+ this.work.pageCoverImg) + ')' }">
            </div>
        </div>
        <v-row class="header flex-grow-1 justify-center" data-aos="fade-up" data-aos-delay="300">
            <v-col><router-link :to="{name: 'Home'}"><h5>NICKY</h5></router-link></v-col>
        </v-row>
        <v-container ref="about" class="d-flex flex-column full-screen" style="z-index: 30" data-aos="fade-up" data-aos-delay="300">
            <v-row>
                <v-col class="col-md-7 col-12 text-md-left align-self-center">
                        <div>
                            <p class="pb-2 small-uppercase accent-color">{{this.work.year}}</p>
                            <h1 class="pb-1">{{this.work.title}}</h1>
                            <h4 class="w500 pt-6 grey-text-600">{{this.work.description}}</h4>
                        </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row>
                <v-col class="col-12">
                    <h2>Project Overview</h2>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-4 my-8 my-md-16 mx-0">
                <v-col class="col-md-4 col-12 pb-md-6 pb-1">
                    <h4 class="pb-3">Duration</h4>
                    <p class="grey-text-600">{{this.work.duration}}</p>
                </v-col>
                <v-col class="col-md-4 col-12 pb-md-6 pb-1">
                    <h4 class="pb-3">Team</h4>
                    <ul>
                        <li v-for="(teammate, index) in work.team" :key="index" class="grey-text-600">{{teammate}}</li>
                    </ul>
                </v-col>
                <v-col class="col-md-4 col-12 pb-md-6 pb-1">
                    <h4 class="pb-3">Target Audience</h4>
                    <p class="grey-text-600">{{this.work.targetAudience}}</p>
                </v-col>
                <v-col class="col-md-4 col-12 pb-md-6 pb-1">
                    <h4 class="pb-3">My Roles</h4>
                    <ul>
                        <li v-for="(role, index) in work.roles" :key="index" class="grey-text-600">{{role}}</li>
                    </ul>
                </v-col>
                <v-col class="col-md-4 col-12 pb-md-6 pb-1">
                    <h4 class="pb-3">Tools</h4>
                    <ul>
                        <li v-for="(tool, index) in work.tools" :key="index" class="grey-text-600">{{tool}}</li>
                    </ul>
                </v-col>
                <v-col class="col-md-4 col-12 pb-md-6 pb-1">
                    <h4 class="pb-3">Method</h4>
                    <p class="grey-text-600">{{this.work.method}}</p>
                </v-col>
            </v-row>
        </v-container>
        <component :is="work.processComponent"></component>
    </div>
</template>

<script>
import ReimagingOnboardingProcess from './ReimagingOnboardingProcess.vue';
import SeamlessSignUp from './SeamlessSignUp.vue';
import IncreasePlatformLead from './IncreasePlatformLead.vue';

export default {
  components: { ReimagingOnboardingProcess, SeamlessSignUp, IncreasePlatformLead},
    name: 'WorkDetails',
    props: {
        id: {type: Number},
    },
    async created() {
        await this.loadWork();
    },
    data(){
        return{
            work: [],
        }
    },
    methods: {
        async loadWork() {
            const [error, result] = await this.$workRepository.getWorkDetails(this.id);

            if(error) {
                console.log('getWorkFailed');
            } else {
                this.work = result;
            }

            console.log(work.processComponent);
        },
    },
}
</script>

<style lang="scss" scoped>

    @import '../App.scss';

    .work-details {
        background: linear-gradient(180deg, #263238 0%, #455A64 10%, #263238 100%);
        color: $blue-grey-color-50;

        h1,h2,h3,h4 {
            color: $blue-grey-color-50;
        }

        p {
            color: $blue-grey-color-200;
        }
    }

    .parallax {
        // min-height: 500px;
        // background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .card-subsection__content {
        border: 1px solid $grey-color-800;
        background: hsla(210, 11%, 15%,.3);
        border-radius: 22px;
    }
</style>


// WEBPACK FOOTER //
// src/views/WorkDetails.vue